/* eslint-disable react/jsx-props-no-spreading */
/**
 * @fileoverview Componente Organism optimizado para mostrar acordeón de detalles del cliente en el Inbox.
 * Utiliza arquitectura de separación de capas y hooks UI Layer para máxima mantenibilidad y performance.
 *
 * - La estructura y contenidos de los paneles provienen de `useCustomerDetailsAccordionPanelsUI` (UI Layer)
 * - El estado de panel abierto y configuración de íconos proviene de `useCustomerDetailsAccordionUI` (UI Layer)
 * - Cumple Atomic Design y separación estricta de lógica de UI y presentación
 */
import React, { memo } from "react";
import { useSelector } from "react-redux";
import { useTraceUpdate } from "../../../hooks/shared/useDebugRenders";
import IconMC from "../../../components/IconMC";
import useCustomerDetailsAccordionUI from "../../../hooks/inbox/ui/useCustomerDetailsAccordionUI";
import useCustomerDetailsAccordionPanelsUI from "../../../hooks/inbox/ui/useCustomerDetailsAccordionPanelsUI";

const CustomerDetailsAccordionMC = memo(({ conversation, customer }) => {
  const aiCopilotsEnabled = useSelector(
    (state) => state.retailerUsersReducer.retailer_info?.ai_copilots_enabled
  );
  const defaultPanel = aiCopilotsEnabled ? 'lead_score' : null;

  const {
    openPanel,
    handlePanelToggle,
    getIconConfig
  } = useCustomerDetailsAccordionUI(defaultPanel);

  // Debug render tracking solo en desarrollo
  useTraceUpdate('CustomerDetailsAccordionMC', {
    conversationId: conversation?.id,
    customerId: customer?.id,
    openPanel,
    conversationKeys: Object.keys(conversation || {}).length
  }, {
    logRenderCount: true,
    logPropChanges: true
  });

  // Paneles del acordeón (UI Layer)
  const accordionPanels = useCustomerDetailsAccordionPanelsUI({
    conversation,
    customer
  });

  return (
    <div className="tw-wrapper">
      {accordionPanels.map((panel) => (
        <div key={panel.key} className="tw-w-full tw-border-t tw-border-gray-200 tw-py-4">
          <div className="tw-flex tw-justify-between tw-items-center tw-flex-shrink-0">
            <div
              className="tw-text-sm tw-font-medium tw-text-gray-950 tw-cursor-pointer"
              onClick={() => handlePanelToggle(panel.key)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => { if (e.key === 'Enter' || e.key === ' ') handlePanelToggle(panel.key); }}
            >
              {panel.title}
            </div>
            <IconMC {...getIconConfig(panel.key)} onClick={() => handlePanelToggle(panel.key)} />
          </div>
          {openPanel === panel.key && panel.content}
        </div>
      ))}
    </div>
  );
});

CustomerDetailsAccordionMC.displayName = "CustomerDetailsAccordionMC";

export default CustomerDetailsAccordionMC;
